import React from 'react'
import { Navigate } from 'react-router-dom'

const UnauthenticatedRoute = ({ isAuth, children, redirectTo }) =>
  !isAuth ? children : <Navigate to={redirectTo} replace />

export default UnauthenticatedRoute
